import React, { useContext, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { mdiStar, mdiLightbulb, mdiPen, mdiCloudDownload } from '@mdi/js';
import Icon from '@mdi/react';
import { Context } from '../../pages/home.page';
import instance from '../../api/api';
import { useNavigate } from 'react-router-dom';
import { navigatedToRequest } from './requests/story-requests-create.component';
import { IStory } from '../../interfaces/story';
import { useTranslation } from "react-i18next";
import Notification, { notificationImages } from "../notifications/notification.component";
import { INotification, NotificationType } from "../../interfaces/notification";

interface IProps {
    show: boolean
    onHide: () => void
    author: boolean
    redirect: Function
    story: IStory
}

export default function StoryActionModal(props:IProps){

    const loggedInUserData = useContext(Context).user;
    const updateLoggedInUserData = useContext(Context).setUserDetails;
    const navigate = useNavigate();
    const [downloading, setDownloading] = useState(false);
    const [downloadError, setDownloadError] = useState<INotification | null>(null);

    const { t } = useTranslation();

    async function downloadStory() {
        setDownloading(true);
        setDownloadError(null);
        try {
            const response = await instance.get(`/publishedstories/${props.story._id}/download`, {
                responseType: 'blob',
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${props.story.title || 'story'}.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            props.onHide();
        } catch (error: any) {
            const status = error?.response?.status;
            if (status === 429) {
                setDownloadError({ icon: notificationImages.noimage, title: t("Too many requests"), text: t("Too many download requests. Please try again later."), success: NotificationType.problem });
            } else {
                setDownloadError({ icon: notificationImages.noimage, title: t("Download failed"), text: t("Download failed. Please try again."), success: NotificationType.problem });
            }
        } finally {
            setDownloading(false);
        }
    }

    async function addtoReadLater() {
        if(!loggedInUserData.readLaterStories.includes(props.story._id)) {
            const response = await instance.put(`/user/${loggedInUserData._id}`, { push: { "readLaterStories": props.story._id }});
            updateLoggedInUserData(response.data)
        }
        else {
            const response = await instance.put(`/user/${loggedInUserData._id}`, { pull: { "readLaterStories": props.story._id }});
            updateLoggedInUserData(response.data)
        }
    }

    async function  addToFavorites() {
        if(!loggedInUserData.favorites.stories.includes(props.story._id)) {
            const response = await instance.put(`/user/${loggedInUserData._id}`, { push: { "favorites.stories": props.story._id }});
            updateLoggedInUserData(response.data)
        }
        else {
            const response = await instance.put(`/user/${loggedInUserData._id}`, { pull: { "favorites.stories": props.story._id }});
            updateLoggedInUserData(response.data)
        }
    }

    return(
        <Modal className="story-action-modal" show={props.show} onHide={props.onHide}>
            <Modal.Header className="" closeButton>
            </Modal.Header>
            <Modal.Body className="edit-card-content">
                <div className="link-row" onClick={addToFavorites}>
                    <Icon size={1} path={ mdiStar } /><p className="main-text-info">{loggedInUserData.favorites.stories.includes(props.story._id) ? t("Remove from Favourite Stories") : t("Add to Favourite Stories")}</p>
                    <p className="info-text">{t("For easy future access")}</p>
                </div>
                {!props.author && <div className="link-row" onClick={addtoReadLater}>
                    <Icon size={1} path={ mdiPen } /><p className="main-text-info">{loggedInUserData.readLaterStories.includes(props.story._id) ? t("Remove from Read Later List") : t("Add to Read Later List")}</p>
                    <p className="info-text">{t("For easy access later")}</p>
                </div>}
                <div className="link-row" onClick={() => navigate({pathname: '/dashboard/requests'}, {state: { from:navigatedToRequest.STORY, id: props.story._id, data:props.story.title }}) }>
                    <Icon size={1} path={ mdiLightbulb } /><p className="main-text-info">{t("Attach to 'Story Request'")}</p>
                    <p className="info-text">{t("Attach to Story Request as example story")}</p>
                </div>
                <div className={`link-row${downloading ? ' disabled' : ''}`} onClick={downloadStory}>
                    {downloading ? <Spinner animation="border" size="sm" /> : <Icon size={1} path={mdiCloudDownload} />}
                    <p className="main-text-info">{downloading ? t("Preparing download…") : t("Download Story")}</p>
                    <p className="info-text">{t("Download as PDF and media archive")}</p>
                </div>
                {downloadError && <Notification data={downloadError} close={() => setDownloadError(null)} />}
                {props.author && <div className="link-row" onClick={() => props.redirect()}>
                    <Icon size={1} path={ mdiPen } /><p className="main-text-single">{t("Edit Story")}</p>
                </div>}
            </Modal.Body>
        </Modal>
    );
}